// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { MediaMessage_abstract } from './../abstract/SagaSchema/MediaMessage_abstract';
export class MediaMessage extends MediaMessage_abstract {}
